/**
 * @generated SignedSource<<6981c1775f5c95eaeb14c320a8c9f4e1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrganizationUsersDeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type OrganizationUsersDeleteMutation$data = {
  readonly removeOrganizationMember: string;
};
export type OrganizationUsersDeleteMutation = {
  response: OrganizationUsersDeleteMutation$data;
  variables: OrganizationUsersDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": (v2/*:: as any*/),
  "kind": "ScalarField",
  "name": "removeOrganizationMember",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrganizationUsersDeleteMutation",
    "selections": [
      (v3/*:: as any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "OrganizationUsersDeleteMutation",
    "selections": [
      (v3/*:: as any*/),
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "filters": null,
        "handle": "deleteEdge",
        "key": "",
        "kind": "ScalarHandle",
        "name": "removeOrganizationMember",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "a9497fecdff4d123531ccbb724c40e54",
    "id": null,
    "metadata": {},
    "name": "OrganizationUsersDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation OrganizationUsersDeleteMutation(\n  $id: ID!\n) {\n  removeOrganizationMember(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "8780852b28f439530d50386b713b77af";

export default node;
